import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu-service.service';
import { environment } from 'src/environments/environment';
import { UserRegistrationService } from 'src/app/services/user-registration.service';
import { AuthService } from 'src/app/services/auth.service';
import { PgNoticeComponent } from '../noticebar/pg-notice.component';
import { UserRegistrationComponent } from '../user-registration/user-registration.component';

@Component({
  standalone: true,
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: [
    './global-header.component.scss',
    '../../styles/portalmenu.common.scss',
    '../../styles/global-header.scss'
  ],
  imports: [
    PgNoticeComponent,
    UserRegistrationComponent
  ]
})

export class GlobalHeaderComponent implements OnInit, OnDestroy {
  @Input() menuLoading: boolean;
  @Input() isUserLoggedIn: boolean;
  @Input() isFederationLoaded: boolean;
  @Input() userEmail: string;
  @Input() hideLogout: boolean = false;
  @Output() logoutClicked: EventEmitter<any> = new EventEmitter();
  public mainMenuActive = false;
  public enableSingleSignOn = false;
  private $subscriptions: Subscription = new Subscription();


  constructor(
    @Inject(DOCUMENT) private document: Document,
    public menuService: MenuService,
    public authService: AuthService,
    public userRegistrationService: UserRegistrationService,
    public route: Router
  ) {
    this.enableSingleSignOn = environment.EnableSingleSignOn;
  }

  ngOnInit(): void {
  }

  public emitCloseMenu(): void {
    this.menuService.emitCloseMenu();
  }

  public menuWasClicked(): void {
    this.menuService.emitMenuService(!this.mainMenuActive);
  }

  onLogoutClicked() {
    this.logoutClicked.emit();
  }

  unsubscribe() {
    if (this.$subscriptions) {
        this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
      this.unsubscribe();
  }

}
